// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1QOrn","actions":"GroupTable_actions__20rz2","deleteModalFooter":"GroupTable_deleteModalFooter__3uyTf"};